// extracted by mini-css-extract-plugin
module.exports = {"block":"discovery-phase-types-section_block__0IMjL","block__item":"discovery-phase-types-section_block__item__rh2uQ","image":"discovery-phase-types-section_image__xgjNo"};